import type { ElementType, ReactNode } from "react";
import { IconPlus } from "@tabler/icons-react";
import Button from "../UI/Button";
import Status from "../UI/Status";
import Text, { type Color } from "../UI/Text";
import Tooltip from "../UI/Tooltip";
import styles from "./StatusCell.module.css";

interface StatusCellProps {
  /** `badge` : pastille colorée ; `add` : bouton « Ajouter » ; `muted` : texte discret (non requis). */
  variant: "badge" | "add" | "muted";
  text?: string;
  color?: Color;
  icon?: ElementType;
  onClick?: () => void;
  tooltip?: ReactNode;
}

/** Cellule d'état des tableaux de pilotage (documents locataires, diagnostics). */
export default function StatusCell({
  variant,
  text,
  color = "neutral",
  icon,
  onClick,
  tooltip,
}: StatusCellProps) {
  let content: ReactNode;
  if (variant === "add") {
    content = (
      <Button variant="secondary" size="sm" icon={IconPlus} onClick={onClick}>
        {text ?? "Ajouter"}
      </Button>
    );
  } else if (variant === "muted") {
    content = onClick ? (
      <button type="button" className={styles.mutedButton} onClick={onClick}>
        <Text as="span" variant="deci">
          {text}
        </Text>
      </button>
    ) : (
      <Text as="span" variant="deci">
        {text}
      </Text>
    );
  } else if (onClick) {
    content = (
      <Status
        as="button"
        type="button"
        color={color}
        text={text}
        icon={icon}
        weight="medium"
        className={styles.clickable}
        onClick={onClick}
      />
    );
  } else {
    content = (
      <Status as="span" color={color} text={text} icon={icon} weight="medium" />
    );
  }
  return tooltip ? <Tooltip content={tooltip}>{content}</Tooltip> : content;
}
